import * as React from 'react';
import { Lang } from '../../enums'
import { enumToDropdownArray } from '../../functions/helperFunctions';
import { DropdownModel } from '../../../models/dropdownModel';

interface IProps {
    onLangChange: any,
    selectedLang: number
}

interface IState {
    languages: Array<DropdownModel>
}

class Language extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            languages: new Array<DropdownModel>(0)
        }
    }

    componentDidMount() {
        let langs = enumToDropdownArray(Lang);
        this.setState({ languages: langs });
    }

    handleChangeLang = (lang) => {
        this.props.onLangChange(lang);
    }

    public render() {
        return (
            <div className="language-container">
                {this.state.languages.map(l =>
                    <div key={l.value}
                        onClick={() => this.handleChangeLang(l.value)}
                        className={this.props.selectedLang == l.value ? "language-item-active" : "language-item"}>
                        {l.label.toLocaleUpperCase()}
                    </div>
                )}
            </div>
        )
    }
}

export default Language;